// ModalComponent.js
import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import styled from "styled-components";
import Button from "@mui/material/Button";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import { gql } from "@apollo/client";
import { client } from "../../../client";
import FileUploaderV1 from "../admin-document/FileUploaderV1";
import { uploadFileWithPresignedUrl } from "../../../utils/s3Uploader";

const ModalContainer = styled(Box)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 70%;
  background-color: white; /* Change to white background */
  padding: 20px;
  z-index: 100;
  border: 1px solid #ccc; /* Add a subtle border */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Add a subtle box shadow */
`;

const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  // align-items: center; /* Center-align all children */
  margin-top: 30px;
  margin-bottom: 30px;
`;

const UserInfoItem = styled.div`
  display: flex; /* Display children in a row */
  flex-direction: row;
  margin-bottom: 50px; /* Add margin between child components */
`;

const BannerModal = ({
  isOpen,
  data,
  handleCloseClick,
  refetchParentData,
  children,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleUploadAndSave = async () => {
    setIsLoading(true);
    try {
      let finalImageUrl = data.image_url;

      if (selectedFile) {
        finalImageUrl = await uploadFileWithPresignedUrl(client, selectedFile);
        handleInputChange("image_url", finalImageUrl);
      }

      handleBannerSave(finalImageUrl);
    } catch (err) {
      alert(`업로드 중 오류가 발생했습니다: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const [editableData, setEditableData] = useState({});
  useEffect(() => {
    console.log("data...", data);

    setEditableData({
      id: data?.id || "",
      title: data?.title || "",
      image_url: data?.image_url || "",
      visible: data?.visible,
    });
  }, [data]);

  const handleInputChange = (key, value) => {
    setEditableData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  const handleBannerSave = (banner_image_url) => {
    const UPDATE_BANNER_INFO = gql`
      mutation updateBannerImageByAdmin(
        $id: Int
        $title: String
        $image_url: String
        $visible: Boolean
      ) {
        updateBannerImageByAdmin(
          id: $id
          title: $title
          image_url: $image_url
          visible: $visible
        ) {
          message
        }
      }
    `;

    client
      .mutate({
        mutation: UPDATE_BANNER_INFO,
        variables: {
          ...editableData,
          image_url: banner_image_url,
          visible: editableData.visible == 1 ? true : false,
        },
      })
      .then((res) => {
        alert("업데이트가 완료됐습니다.", res);
        refetchParentData();
        handleCloseClick();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  if (!isOpen) return null;

  return (
    <ModalContainer>
      <h2> 배너 정보 수정 </h2>

      <UserInfoContainer>
        {Object.keys(data).map((key) => {
          if (key == "__typename") return null;

          return (
            <div key={key}>
              {key === "title" ? (
                <UserInfoItem>
                  <div>
                    <label>{key}: </label>
                  </div>
                  <div>
                    <input
                      type="text"
                      value={editableData[key]}
                      onChange={(e) => handleInputChange(key, e.target.value)}
                    />
                  </div>
                </UserInfoItem>
              ) : key === "visible" ? (
                <UserInfoItem>
                  <Typography>노출 여부</Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={editableData.visible}
                          onChange={(e) =>
                            handleInputChange("visible", e.target.checked)
                          }
                        />
                      }
                    />
                  </FormGroup>
                </UserInfoItem>
              ) : key === "id" ? (
                <UserInfoItem>
                  {key} : {data[key]}
                </UserInfoItem>
              ) : key === "image_url" ? (
                <UserInfoItem>
                  {"배너이미지 : "}
                  <FileUploaderV1
                    setSelectedFile={setSelectedFile}
                    selectedFile={selectedFile}
                  ></FileUploaderV1>
                </UserInfoItem>
              ) : (
                <UserInfoItem>
                  {key} : {data[key]}
                </UserInfoItem>
              )}
            </div>
          );
        })}
      </UserInfoContainer>
      <Button
        variant="contained"
        onClick={handleUploadAndSave}
        disabled={isLoading}
      >
        {isLoading ? "저장 중..." : "저장"}
      </Button>
      <Button onClick={() => handleCloseClick()}> 닫기 </Button>
    </ModalContainer>
  );
};

export default BannerModal;
